import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Hero, SectionWidget, QuickLinks } from '../blocks/all-blocks';
import '../styles/creations.css';
import posts from '../posts';

const Notes = ({ transfile }) => {
  const { t } = useTranslation();
  const [displayMethod, setDisplayMethod] = useState(true);

  const recentNine = posts.map(post => ({
    num: post.num,
    title: post.title,
    description: post.description,
    url: `/notes/${post.slug}`,
    date: post.date,
    tags: post.tags,
    views: post.views
  }));

  const quickLinks = [
    { name: t('quickLinks.knowledge'), url: '/knowledge' },
    { name: t('quickLinks.travel'), url: '/travel' },
    { name: t('quickLinks.aboutMe'), url: '/me' }
  ];

  return (
    <div className="cont-body">
      <Hero translation={transfile}/>
      <SectionWidget sectionName={t('recentNotes')} recentNine={recentNine} url='/notes' displayMethod={displayMethod} setDisplayMethod={setDisplayMethod} defaultItemsShowed={9}/>
      <QuickLinks list={quickLinks} />
    </div>
  );
};

export default Notes;
